// src/components/ScrollToTop.jsx
//
// Em SPA o browser NÃO reseta o scroll ao trocar de rota. Sem isto, o usuário
// rola a Home e, ao clicar em "Iniciar consulta" / /reviews / /diretor (ou
// qualquer outra rota), a tela de destino abre no mesmo scrollY — parece
// "ponto aleatório" / foco no meio da página.
//
// Escuta pathname + hash. Respeita âncoras (#secao). Desliga a restauração
// nativa do browser para não brigar com este reset.

import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

let scrollRestorationArmed = false;

function armManualScrollRestoration() {
  if (scrollRestorationArmed) return;
  scrollRestorationArmed = true;
  try {
    if (typeof window !== 'undefined' && window.history?.scrollRestoration) {
      window.history.scrollRestoration = 'manual';
    }
  } catch {
    // ignore
  }
}

export function scrollWindowToTop() {
  if (typeof window === 'undefined') return;
  try {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  } catch {
    window.scrollTo(0, 0);
  }
  if (document.documentElement) document.documentElement.scrollTop = 0;
  if (document.body) document.body.scrollTop = 0;
}

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    armManualScrollRestoration();

    if (hash && hash.length > 1) {
      const id = decodeURIComponent(hash.slice(1));
      const el = id ? document.getElementById(id) : null;
      if (el) {
        el.scrollIntoView();
        return;
      }
    }

    scrollWindowToTop();
  }, [pathname, hash]);

  return null;
}
